module.exports = __webpack_public_path__ + "img/01.bea3a513.png";